export function makeId(prefix: number|string) {
  return Math.random().toString(36).replace('0.', String(prefix) || '');
}
